import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-crane-md border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-crane-ring focus:ring-offset-2 focus:ring-offset-crane-background",
  {
    variants: {
      variant: {
        default: "border-transparent bg-crane-primary text-crane-primary-foreground hover:bg-crane-primary/80",
        secondary:
          "border-transparent bg-crane-secondary text-crane-secondary-foreground hover:bg-crane-secondary/80",
        destructive:
          "border-transparent bg-crane-destructive text-crane-destructive-foreground hover:bg-crane-destructive/80",
        outline: "border-crane-border text-crane-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
